var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmitCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "q7o352ykca"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#q7o352ykca)",
    transform: "translate(-766 -1752) translate(718) translate(0 1442) translate(0 256) translate(32 40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M19.975 4.1l-2.324 9.063c-.088.345-.4.587-.756.587H3.905c-.43 0-.78-.35-.78-.781V1.563H.78C.35 1.563 0 1.212 0 .78 0 .35.35 0 .781 0h3.125c.431 0 .781.35.781.781v2.344h14.531c.51 0 .884.482.757.975zm-1.763.588H4.687v7.5h11.601l1.924-7.5zm-10.4 12.968C7.812 18.95 6.761 20 5.468 20c-1.292 0-2.343-1.051-2.343-2.344 0-1.292 1.051-2.343 2.343-2.343 1.293 0 2.344 1.05 2.344 2.343zm-1.562 0c0-.43-.35-.781-.782-.781-.43 0-.78.35-.78.781 0 .431.35.782.78.782.431 0 .782-.351.782-.782zm9.886 0c0 1.293-1.051 2.344-2.344 2.344-1.292 0-2.343-1.051-2.343-2.344 0-1.292 1.05-2.343 2.343-2.343s2.344 1.05 2.344 2.343zm-1.562 0c0-.43-.351-.781-.782-.781-.43 0-.781.35-.781.781 0 .431.35.782.781.782.431 0 .782-.351.782-.782z",
    transform: "translate(16 14)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M7.5 8.5L12.5 8.5M11.5 6.5L13.5 8.5M13.5 8.5L11.5 10.5",
    transform: "translate(16 14)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitCart);
export default __webpack_public_path__ + "static/media/submit-cart.f3227fe8274c659e583e1cb0237c014b.svg";
export { ForwardRef as ReactComponent };